import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow } from '@mui/material';
import { sequence } from '@totalsoft/change-tracking-react';
import FinancialProductResidualGridsTableRow from './FinancialProductResidualGridsTableRow';
import { useTranslation } from 'react-i18next';
import { isValid } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';

const FinancialProductResidualGridsTableBody = ({ canWrite, onCancelEdit, onDelete, onSave, residualGrids, residualValueGridList, validation, isDirty }) => {
  const [t] = useTranslation();

  return (
    <TableBody>
      {!isValid(validation) &&
        !sequence(residualGrids)?.find((_, index) => {
          return !isValid(validation[index]);
        }) && (
          <TableRow>
            <Typography color='error'>{t('FinancialProduct.Details.ResidualValueGrids.ValidationList')}</Typography>
          </TableRow>
        )}
      {sequence(residualGrids)?.map((data, index) => {
        return (
          <FinancialProductResidualGridsTableRow
            canWrite={canWrite}
            key={index}
            dataLens={data}
            index={index}
            onCancelEdit={onCancelEdit}
            onDelete={onDelete}
            onSave={onSave}
            residualValueGridList={residualValueGridList}
            validation={validation}
            isDirty={isDirty}
          />
        );
      })}
    </TableBody>
  );
};

FinancialProductResidualGridsTableBody.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  residualGrids: PropTypes.array.isRequired,
  residualValueGridList: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired,
  isDirty: PropTypes.bool.isRequired
};

export default FinancialProductResidualGridsTableBody;
